import axios from 'axios';

// ApiAccess Functions
/**
 */
export const getClipItems = async (headers, data) => {
  // console.log('start getClipItems');
  let retParam;
  try {
    // console.log('data', data);
    // console.log('headers', headers);
    const NoDataheader = headers;
    await axios
      .get(
        `${process.env.REACT_APP_FINDOUT_WP_API_URL}/clip_items?provider_userid=${data.provider_userid}&per_page=${data.per_page}&page=${data.page}`,
        { headers: NoDataheader }
      )
      .then((result) => {
        // console.log('result', result);
        retParam = result;
      });
  } catch (e) {
    // console.log('error', e);
  }
  // console.log('retParam', retParam);
  // console.log('end getClipItems');
  return retParam;
};

export const addClipItem = async (headers, data) => {
  // console.log('start addClipItem');
  let retParam;
  try {
    // console.log('data', data);
    // console.log('headers', headers);
    const NoDataheader = headers;
    await axios.post(`${process.env.REACT_APP_FINDOUT_WP_API_URL}/clip_save`, data, { headers: NoDataheader }).then((result) => {
      // console.log('result', result);
      retParam = result;
    });
  } catch (e) {
    // console.log('error', e);
  }
  // console.log('retParam', retParam);
  // console.log('end addClipItem');
  return retParam;
};

export const deleteClipItem = async (headers, data) => {
  // console.log('start deleteClipItem');
  let retParam;
  try {
    // console.log('data', data);
    // console.log('headers', headers);
    const NoDataheader = headers;
    await axios.delete(`${process.env.REACT_APP_FINDOUT_WP_API_URL}/clip_delete`, { data, headers: NoDataheader }).then((result) => {
      // console.log('result', result);
      retParam = result;
    });
  } catch (e) {
    // console.log('error', e);
  }
  // console.log('retParam', retParam);
  // console.log('end addClipItem');
  return retParam;
};
